import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionSituacionActividadByID = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionSituacionActividadByID = () => {
  const [loadingGetDeclaracionSituacionActividadByID, setLoadingGetDeclaracionSituacionActividadByID] = useState(false);
  const [successGetDeclaracionSituacionActividadByID, setSuccessGetDeclaracionSituacionActividadByID] = useState(false);
  const [errorGetDeclaracionSituacionActividadByID, setErrorGetDeclaracionSituacionActividadByID] = useState<any>(null);
  const [dataGetDeclaracionSituacionActividadByID, setDataDeclaracionSituacionActividad] = useState<any>(null);

  const [statusGetDeclaracionSituacionActividadByID, setStatusGetDeclaracionSituacionActividadByID] =
    useState<StatusGetDeclaracionSituacionActividadByID>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // GET
  const getDeclaracionSituacionActividadByID = async (
    userId: string,
    prestacionId: string,
    id: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionSituacionActividadByID(true);
    setSuccessGetDeclaracionSituacionActividadByID(false);
    setErrorGetDeclaracionSituacionActividadByID(null);

    try {
      const res = await apiRecord.getDeclaracionSituacionActividadItByID(
        userId,
        prestacionId,
        id
      );

      setStatusGetDeclaracionSituacionActividadByID({
        status: res.status,
        statusText: res.statusText ?? res.response ?? null
      });

      setSuccessGetDeclaracionSituacionActividadByID(true);
      setDataDeclaracionSituacionActividad(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {
      const responseData = err?.response?.data;
      const backendMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.response ||
        responseData?.message ||
        err?.response?.statusText ||
        err?.message ||
        "Error";

      setStatusGetDeclaracionSituacionActividadByID({
        status: err?.response?.status || 500,
        statusText: backendMessage
      });

      setErrorGetDeclaracionSituacionActividadByID(err);
      console.error("Error en getDeclaracionSituacionActividadByID:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionSituacionActividadByID(false);
    }
  };

  return {
    getDeclaracionSituacionActividadByID,
    loadingGetDeclaracionSituacionActividadByID,
    successGetDeclaracionSituacionActividadByID,
    errorGetDeclaracionSituacionActividadByID,
    dataGetDeclaracionSituacionActividadByID,
    statusGetDeclaracionSituacionActividadByID
  };
};

export default useGetDeclaracionSituacionActividadByID;
